import { gql } from "@apollo/client";

export const GET_OBJECTS = gql`
  query GetAllObjects {
    allMdmObjects {
      id
      title
    }
  }
`;

export const GET_OBJECTS_BY_PROJECT = gql`
  query GetObjectsByProject($id: String!){
    mdmObjectsByProjectId(projectId: $id) {
      address {
        fullAddress
      }
      id
      location {
        latitude
        longitude
      }
      tags
      title
    }
  }
`;

export const GET_OBJECT = gql`
  query GetObject($id: String!) {
    mdmObjectById(id: $id) {
      address {
        city
        country
        houseNumber
        postCode
        street
      }
      customFields {
        key
        value {
          type
          value
        }
      }
      description
      deviceRelations {
        mdmDevice {
          id
          identifier
          tags
          modifiedAt
          createdAt
        }
      }
      id
      location {
        latitude
        longitude
      }
      tags
      title
    }
  }
`;

export const CREATE_OBJECT = gql`
  mutation CreateObject($object: MdmObjectDTOInput!) {
    createMdmObject(input: $object) {
      id
      title
      description
      tags
      address {
        city
        country
        houseNumber
        postCode
        street
      }
      location {
        latitude
        longitude
      }
    }
  }
`;

export const UPDATE_OBJECT = gql`
  mutation UpdateObject($object: MdmObjectDTOInput!) {
    updateMdmObject(input: $object) {
      id
      title
      description
      tags
      address {
        city
        country
        houseNumber
        postCode
        street
      }
      location {
        latitude
        longitude
      }
    }
  }
`;

export const DELETE_OBJECT = gql`
  mutation DeleteObject($id: String!) {
    deleteMdmObject(id: $id) {
      id
      title
    }
  }
`;
